import * as React from 'react'

function SvgComponent(props) {
   return (
      <svg
         width={31}
         height={30}
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         {...props}
      >
         <path
            d="M15.605 7.486C11.46 7.486 8.09 10.857 8.09 15c0 4.143 3.37 7.514 7.514 7.514 4.142 0 7.514-3.37 7.514-7.514s-3.372-7.515-7.514-7.515zM15.605 5.277c-.81 0-1.466-.656-1.466-1.465V1.466a1.466 1.466 0 112.932 0v2.346c0 .809-.657 1.465-1.466 1.465zM15.605 24.722c-.81 0-1.466.656-1.466 1.466v2.345a1.466 1.466 0 102.932 0v-2.345c0-.81-.657-1.466-1.466-1.466zM22.479 8.125a1.467 1.467 0 010-2.073l1.659-1.66a1.467 1.467 0 012.073 2.074l-1.659 1.659c-.572.573-1.5.573-2.073 0zM8.73 21.876a1.465 1.465 0 00-2.074 0l-1.658 1.658a1.466 1.466 0 002.073 2.073l1.659-1.66c.572-.571.572-1.5 0-2.071zM25.326 15c0-.81.657-1.466 1.466-1.466h2.346a1.466 1.466 0 110 2.931h-2.346c-.81 0-1.466-.655-1.466-1.465zM5.882 15c0-.81-.657-1.466-1.466-1.466H2.07a1.466 1.466 0 100 2.931h2.345c.81 0 1.466-.655 1.466-1.465zM22.478 21.876a1.467 1.467 0 012.074 0l1.658 1.659a1.465 1.465 0 11-2.073 2.072l-1.659-1.659a1.465 1.465 0 010-2.072zM8.73 8.125c.573-.572.573-1.5 0-2.073L7.07 4.394a1.466 1.466 0 00-2.073 2.072l1.659 1.66c.572.573 1.5.573 2.073 0z"
            fill={props.color || '#CC1F1F'}
         />
      </svg>
   )
}

export default SvgComponent
